import React, { useState } from "react";
import StyledWelcome from "./styles";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import parse from "html-react-parser";
import Login from "../Login";
import Modal from "react-bootstrap/Modal";
export default function Welcome({
  textContent,
  imageContent,
  loggedIn,
  setLoggedIn,
}) {
  const [success, setSuccess] = useState(false);
  return (
    <StyledWelcome $imageContent={imageContent}>
      { textContent ? (
        <Container>
          <Row>
            <Col className="title-col">
              <div className="title-box">
                <h1 className="title">{parse(textContent?.title)}</h1>
                <h3 className="subtitle">{parse(textContent?.subtitle)}</h3>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className="subtext">{parse(textContent?.subtext)}</p>
            </Col>
          </Row>
        </Container>
       ) : null}
      
    </StyledWelcome>
  );
}
